/**
 * @desc query
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(receiveType: string | number, receiveCode: string | number, options?: any) {
  return updateResponse(
    http(URL + `/query/users/${receiveType}/${receiveCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
